import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withViewTransitions } from '@angular/router';
import { KeycloakService, EnvServiceProvider, VlHttpService, ErrorInterceptor } from 'usermgmt'; 

import { ApiResponseInterceptor, AuthInterceptorService, InitService } from 'usermgmt';
import { DatePipe } from '@angular/common';
import { routes } from './app/app.routes';
import { provideZonelessChangeDetection } from '@angular/core';

const keycloakService = new KeycloakService();



keycloakService.init().then(() => {
  console.log('Keycloak initialized, bootstrapping app');
  bootstrapApplication(App, {
    providers: [
      ...(appConfig.providers || []),
      provideHttpClient(withInterceptorsFromDi()),
      provideZonelessChangeDetection(),
      provideRouter(
        routes,
        withViewTransitions({ skipInitialTransition: true }),
      ),
      EnvServiceProvider,
      VlHttpService,
      InitService,
      DatePipe,
      { provide: KeycloakService, useValue: keycloakService },
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiResponseInterceptor,
        multi: true
      },
      {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
  ]
  }).catch(err => console.error('Bootstrap failed:', err));
}).catch(err => {
  console.error('Keycloak init failed:', err);
});


window.addEventListener('error', (e) => {
  if (e.message?.includes('Failed to fetch dynamically imported module')) {
    window.location.reload();
  }
});